/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Beautify is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Beautify is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Beautify, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Beautify:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Follows a 'code splitting' architecture.
 *  - Is completely custom built (no JS libraries other than instant.page)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Beautify broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
 *  4.  on:line-item:change
 *  5.  on:cart:discount-added
 *  6.  on:cart:discount-error
 *  7.  on:cart-drawer:before-open
 *  8.  on:cart-drawer:after-open
 *  9.  on:cart-drawer:after-close
 *  10. on:quickbuy:before-open
 *  11. on:quickbuy:after-open
 *  12. on:quickbuy:after-close
 *  13. dispatch:cart-drawer:open
 *  14. dispatch:cart-drawer:refresh
 *  15. dispatch:cart-drawer:close
 *  16. on:debounced-resize
 *  17. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - product: the product object (includes a list of all variants)
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart. To listen for this, see the
 * on:line-item:change event.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the variant was added
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:line-item:change
 * -------------------------------------------------------------------------------------------------
 * Fires when the quantity of an item already in the cart is updated. Note, if the 'newQuantity' is
 * 0, this indicates the item was removed from that cart.
 *
 * Note, when adding a variant to the cart - this event will fire if that variant is already in the
 * cart (i.e. the quantity is incremented). In this situation, 'on:cart:add' will not fire.
 *
 * How to listen:
 * document.addEventListener('on:line-item:change', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the quantity change was completed
 *   - variantId: id of the variant that was just updated
 *   - newQuantity: new quantity of the line item
 *   - oldQuantity: old quantity of the line item
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart:discount-added
 * -------------------------------------------------------------------------------------------------
 * Fires when a discount code has been successfully applied to the cart.
 * 
 * How to listen:
 * document.addEventListener('on:cart:discount-added', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - code: the discount code that was successfully applied
 * 
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart:discount-error
 * -------------------------------------------------------------------------------------------------
 * Fires when a discount code could not be applied to the cart, for example if the code is invalid
 * or does not meet the requirements.
 * 
 * How to listen:
 * document.addEventListener('on:cart:discount-error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - code: the discount code that failed to apply
 * 
 * 
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 16) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 17) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes. See the 'Media Queries' section in this file
 * for more.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Beautify utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 * =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Beautify only has one third-party dependency: Swiper (https://swiperjs.com/).
 *
 * It's included locally and is only active if the Featured collection or Product list sections 
 * use the ‘coverflow’ effect or if the Product section uses ‘Video testimonial’ block.
 *
 * Swiper is a JavaScript library that lets people swipe or drag through content naturally, and 
 * makes browsing feel more interactive and mobile-friendly.
 *
 *
 *
 * =================================================================================================
 * Code Splitting
 * =================================================================================================
 * We followed the ‘code splitting’ technique when building Beautify.
 *
 * Code splitting consists in writing JavaScript (and CSS)in a modularized way within typically
 * small, more manageable files that can be loaded on-demand, as needed. The idea is to improve the
 * performance of our theme by reducing the amount of code that needs to be loaded upfront.
 *
 * If the customer is visiting a specific page of the theme that requires certain JavaScript
 * functionality, only the code needed for that page will be loaded, rather than one large
 * JavaScript file containing largely unused code. For example, the file media-gallery.js will
 * only be loaded if there is a media gallery on the page.
 *
 * Shopify uses HTTP/2, which is the newer version of the HTTP protocol used to deliver web content.
 * HTTP/2 supports multiplexing, which means that multiple requests can be sent over a single
 * connection at the same time - meaning multiple JS files are essentially served at the speed of a
 * single file.
 *
 * The only JS file which is served on every page in Beautify is 'main.js'. Main.js contains
 * utility JS which is likely to be needed by many scripts. This is outlined more in the next
 * section.
 *
 *
 *
 * =================================================================================================
 * Utilities
 * =================================================================================================
 * Beautify provides a few utility utilities, contained in main.js. Some of the key ones are
 * outlined below. See main.js for more.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 1) Lazy Loading
 * -------------------------------------------------------------------------------------------------
 * Lazy loading is a technique for delaying the loading of certain elements until they are needed,
 * which can help improve page load times.
 *
 * We use three functions used for lazy loading images and scripts in our theme:
 *
 *  - setImageSources function - copies the data-src and data-srcset attributes of lazy loaded
 *    images to their src and srcset attributes.
 *  - initLazyImages function - uses the IntersectionObserver API to lazy load images when needed.
 *  - initLazyScript function - only loads a script when a specific element is scrolled into view.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) Cookies
 * -------------------------------------------------------------------------------------------------
 * Cookies are small pieces of data that can be stored on a user's computer. They can be useful for
 * tracking user activity, remembering user preferences or other similar purposes.
 *
 * We use three functions to manage cookies:
 *
 *  - setCookie function - sets a cookie with a given name, value and number of days until it
 *  should expire.
 *  - getCookie function - takes in the name of a cookie to retrieve its value.
 *  - deleteCookie function - takes in the name of a cookie to delete it.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) Media Queries
 * -------------------------------------------------------------------------------------------------
 * The theme creates a theme.mediaMatches object (in theme.liquid) for several key screen sizes
 * specified in our theme, and adds listeners for each media query.
 *
 * These are:
 *
 * mediaQueries: {
 *  sm: '(min-width: 480px)',
 *  md: '(min-width: 768px)',
 *  lg: '(min-width: 1024px)',
 *  xl: '(min-width: 1280px)',
 *  xxl: '(min-width: 1536px)',
 *  portrait: '(orientation: portrait)'
 * }
 *
 * If a breakpoint is crossed, the mediaMatches values are updated and an 'on:breakpoint-change'
 * event is dispatched.
 *
 * You can request the entire theme.mediaMatches object to check which media queries are currently
 * matched. In this case, the returned data will be an object with the names of the media queries as
 * keys, and boolean values indicating whether they are currently matched or not.
 *
 * Example:
 *
 * {
 *  sm: true,
 *  md: true,
 *  lg: true,
 *  xl: true,
 *  xxl: false,
 *  portrait: false
 * }
 *
 * You can reference a specific media query to check if it's currently matched by using:
 * theme.mediaMatches.lg.
 *
 * To check if you're on mobile you can use:
 * !theme.mediaMatches.md
 *
 * If you want to perform some action when the breakpoint changes, you can listen for the
 * breakpoint-change event on the window object.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  // your code here
 * });
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */

/**
 * Disable product-card hover effects
 * This overrides the default mouseenter/mouseleave behavior to prevent 
 * the card from jumping and showing/hiding elements on hover.
 */
(function() {
  // Wait for DOM to be ready
  function disableProductCardHover() {
    // Get all product cards
    const productCards = document.querySelectorAll('product-card, .product-card');
    
    productCards.forEach(card => {
      // Remove any existing is-open/is-opening/is-closing classes
      card.classList.remove('is-open', 'is-opening', 'is-closing');
      
      // Override the handleMouseEnter and handleMouseLeave methods if they exist
      if (card.handleMouseEnter) {
        card.handleMouseEnter = function() {};
      }
      if (card.handleMouseLeave) {
        card.handleMouseLeave = function() {};
      }
      
      // Remove mouseenter and mouseleave event listeners by cloning
     
      card.addEventListener('mouseenter', function(e) {
        e.stopPropagation();
        this.classList.remove('is-open', 'is-opening', 'is-closing');
      }, true);
      
      card.addEventListener('mouseleave', function(e) {
        e.stopPropagation();
        this.classList.remove('is-open', 'is-opening', 'is-closing');
      }, true);
    });
  }
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableProductCardHover);
  } else {
    disableProductCardHover();
  }
  
  //  run after a short delay to catch any dynamically loaded cards
  setTimeout(disableProductCardHover, 1000);
  setTimeout(disableProductCardHover, 3000);
  
  //  observe for new product cards being added to the DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.matches && (node.matches('product-card') || node.matches('.product-card'))) {
            disableProductCardHover();
          }
          //  check children
          const cards = node.querySelectorAll && node.querySelectorAll('product-card, .product-card');
          if (cards && cards.length > 0) {
            disableProductCardHover();
          }
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
})();

/**
 * Sibling Products Dialog
 * Opens a dialog showing all sibling color options when clicking the swatches pill
 */
(function() {
  function initSiblingDialogs() {
    // Get all swatches trigger buttons
    const triggers = document.querySelectorAll('.card__swatches-trigger');
    
    triggers.forEach(trigger => {
      // Skip if already initialized
      if (trigger.dataset.siblingDialogInit) return;
      trigger.dataset.siblingDialogInit = 'true';
      
      const card = trigger.closest('.product-card, product-card');
      if (!card) return;
      
      const dialogId = trigger.getAttribute('aria-controls');
      // Dialog is now a direct child of product-card (not inside card__info)
      let dialog = card.querySelector('#' + dialogId);
      if (!dialog) {
        // Fallback: try to find by ID in document (in case of different DOM structure)
        dialog = document.getElementById(dialogId);
      }
      if (!dialog) return;
      
      const backBtn = dialog.querySelector('.card__sibling-dialog-back');
      
      // Open dialog on trigger click
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Close any other open dialogs
        document.querySelectorAll('.card__sibling-dialog.is-open').forEach(d => {
          if (d !== dialog) {
            d.classList.remove('is-open');
            d.setAttribute('hidden', '');
          }
        });
        
        // Open this dialog
        dialog.removeAttribute('hidden');
        // Force reflow for animation
        dialog.offsetHeight;
        dialog.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        
        // Focus the back button
        if (backBtn) {
          backBtn.focus();
        }
        
        return false;
      }, true); // Use capture phase
      
      // Also prevent mousedown from propagating
      trigger.addEventListener('mousedown', function(e) {
        e.stopPropagation();
      }, true);
      
      // Close dialog on back button click
      if (backBtn) {
        backBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          dialog.classList.remove('is-open');
          setTimeout(() => {
            dialog.setAttribute('hidden', '');
          }, 250); // Match transition duration
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        });
      }
      
      // Close dialog when clicking outside
      dialog.addEventListener('click', function(e) {
        // Only close if clicking on the dialog background, not its content
        if (e.target === dialog) {
          dialog.classList.remove('is-open');
          setTimeout(() => {
            dialog.setAttribute('hidden', '');
          }, 250);
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Close on Escape key
      dialog.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          dialog.classList.remove('is-open');
          setTimeout(() => {
            dialog.setAttribute('hidden', '');
          }, 250);
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
      
      // Handle sibling option clicks - update product card content
      const siblingOptions = dialog.querySelectorAll('.card__sibling-option');
      siblingOptions.forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const siblingData = {
            id: this.dataset.siblingId,
            variantId: this.dataset.siblingVariantId,
            url: this.dataset.siblingUrl,
            title: this.dataset.siblingTitle,
            price: this.dataset.siblingPrice,
            priceRaw: this.dataset.siblingPriceRaw,
            comparePrice: this.dataset.siblingComparePrice,
            comparePriceRaw: this.dataset.siblingComparePriceRaw,
            image: this.dataset.siblingImage,
            imageAlt: this.dataset.siblingImageAlt,
            available: this.dataset.siblingAvailable === 'true'
          };
          
          // Update the product card with new sibling data
          updateProductCard(card, siblingData);
          
          // Update current selection styling
          siblingOptions.forEach(opt => {
            opt.classList.remove('card__sibling-option--current');
            opt.setAttribute('aria-selected', 'false');
          });
          this.classList.add('card__sibling-option--current');
          this.setAttribute('aria-selected', 'true');
          
          // Update the trigger swatch to show current selection
          const triggerSwatch = trigger.querySelector('.card__swatches-current-swatch img');
          const triggerName = trigger.querySelector('.card__swatches-current-name');
          const optionSwatch = this.querySelector('.card__sibling-option-swatch img');
          
          if (triggerSwatch && optionSwatch) {
            triggerSwatch.src = optionSwatch.src;
            triggerSwatch.srcset = optionSwatch.srcset || '';
            triggerSwatch.alt = siblingData.imageAlt || '';
          }
          
          if (triggerName) {
            const colorName = siblingData.title.split(' / ').pop();
            triggerName.textContent = colorName.length > 20 ? colorName.substring(0, 17) + '...' : colorName;
          }
          
          // Close the dialog
          dialog.classList.remove('is-open');
          setTimeout(() => {
            dialog.setAttribute('hidden', '');
          }, 250);
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }
  
  /**
   * Update product card content with sibling product data
   */
  function updateProductCard(card, data) {
    // Update main product image
    const mainImage = card.querySelector('.card__media .card__main-image');
    if (mainImage && data.image) {
      mainImage.src = data.image;
      mainImage.alt = data.imageAlt || data.title;
      // Update srcset for responsive images
      const widths = [320, 460, 600, 700, 800, 900, 1200];
      const srcset = widths.map(w => {
        const url = data.image.replace(/width=\d+/, 'width=' + w);
        return url + ' ' + w + 'w';
      }).join(', ');
      mainImage.srcset = srcset;
    }
    
    // Update product link URLs
    const productLinks = card.querySelectorAll('.js-prod-link, .card-link');
    productLinks.forEach(link => {
      link.href = data.url;
    });
    
    // Update product title only when switching to a different (sibling) product, not when selecting a variant of the same product
    const cardProductId = card.dataset.productId;
    const isSameProduct = cardProductId && String(data.id) === String(cardProductId);
    if (!isSameProduct) {
      const titleSpan = card.querySelector('.card__title span');
      if (titleSpan) {
        titleSpan.textContent = data.title;
      }
    }
    
    // Update product price
    const priceContainer = card.querySelector('.card__price .price');
    if (priceContainer) {
      const currentPrice = priceContainer.querySelector('.price__current .js-value');
      const wasPrice = priceContainer.querySelector('.price__was .js-value');
      const discountEl = priceContainer.querySelector('.price__discount');
      
      if (currentPrice) {
        currentPrice.textContent = data.price;
      }
      
      // Apply pricing rules based on client requirements
      // Rule 1: If Final Price = Reference Price: Show only current price
      // Rule 2: If Final Price ≠ Reference Price AND Current Price < Reference Price: Show current price, struck-through reference price, and discount percentage
      // Rule 3: If Current Price ≥ Reference Price: Hide reference price completely, show only current price
      
      let showReferencePrice = false;
      let showDiscountPercentage = false;
      let discountPercentage = 0;
      
      // Parse raw price values if available
      const priceRaw = data.priceRaw ? parseInt(data.priceRaw, 10) : null;
      const comparePriceRaw = data.comparePriceRaw ? parseInt(data.comparePriceRaw, 10) : null;
      
      if (comparePriceRaw && comparePriceRaw > 0 && priceRaw !== null) {
        if (priceRaw < comparePriceRaw) {
          // Valid discount scenario - show reference price and percentage
          showReferencePrice = true;
          showDiscountPercentage = true;
          // Calculate discount percentage from Reference Price
          discountPercentage = Math.round(((comparePriceRaw - priceRaw) / comparePriceRaw) * 100);
        }
        // If priceRaw >= comparePriceRaw, show only current price (no discount)
      }
      
      if (wasPrice) {
        if (showReferencePrice && data.comparePrice) {
          wasPrice.textContent = data.comparePrice;
          wasPrice.closest('.price__was').style.display = '';
          priceContainer.classList.add('price--on-sale');
        } else {
          wasPrice.closest('.price__was').style.display = 'none';
          priceContainer.classList.remove('price--on-sale');
        }
      }
      
      // Update discount percentage
      if (discountEl) {
        if (showDiscountPercentage && discountPercentage > 0) {
          discountEl.textContent = `-${discountPercentage}%`;
          discountEl.hidden = false;
        } else {
          discountEl.hidden = true;
        }
      }
    }
    
    // Update add to cart form if present - IMPORTANT for cart functionality
    const addToCartForm = card.querySelector('.card__quick-add form');
    if (addToCartForm && data.variantId) {
      // Update the variant ID input so the correct variant is added to cart
      const variantInput = addToCartForm.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = data.variantId;
        console.log('[SiblingDialog] Updated variant ID in form to:', data.variantId);
      }
    }
    
    // Update sold out state
    const quickAddBtn = card.querySelector('.card__quick-add .btn');
    if (quickAddBtn) {
      if (data.available) {
        quickAddBtn.disabled = false;
        const btnText = quickAddBtn.querySelector('.quick-add-btn-text');
        if (btnText) btnText.textContent = 'Add to bag';
      } else {
        quickAddBtn.disabled = true;
        const btnText = quickAddBtn.querySelector('.quick-add-btn-text');
        if (btnText) btnText.textContent = 'Sold out';
      }
    }
  }
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiblingDialogs);
  } else {
    initSiblingDialogs();
  }
  
  // Also run after delays for dynamically loaded content
  setTimeout(initSiblingDialogs, 1000);
  setTimeout(initSiblingDialogs, 3000);
  
  // Observe for new product cards
  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.querySelector && node.querySelector('.card__swatches-trigger')) {
            shouldInit = true;
          }
          if (node.classList && node.classList.contains('card__swatches-trigger')) {
            shouldInit = true;
          }
        }
      });
    });
    if (shouldInit) {
      initSiblingDialogs();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
})();

// =============================================================================
// SIBLING VARIANT UPDATE - Update form variant ID when sibling is selected
// =============================================================================
// This is handled in the sibling dialog code above - when a sibling is selected,
// we need to also update the variant ID in the add-to-cart form

// =============================================================================
// FREE SHIPPING PROGRESS BAR - Update dynamically on cart changes
// =============================================================================
(function() {
  function formatMoney(cents, currencyCode) {
    const amount = (cents / 100).toFixed(2);
    const symbols = { USD: '$', GBP: '£', EUR: '€', RON: 'lei' };
    const symbol = symbols[currencyCode] || currencyCode || '';

    if (currencyCode === 'RON') {
      return amount.replace('.', ',') + ' ' + symbol;
    }
    if (currencyCode === 'USD' || currencyCode === 'GBP') {
      return symbol + amount;
    }
    return amount.replace('.', ',') + ' ' + symbol;
  }
  
  let shippingBarTimer = null;
  let shippingBarFetching = false;

  function requestShippingBarUpdate() {
    clearTimeout(shippingBarTimer);
    shippingBarTimer = setTimeout(updateFreeShippingBar, 300);
  }

  function updateFreeShippingBar() {
    const container = document.querySelector('.cart-subtotals_freeShipping__container');
    if (!container || shippingBarFetching) return;

    const threshold = parseInt(container.dataset.freeShippingThreshold) || 0;
    if (threshold <= 0) return;

    shippingBarFetching = true;
    fetch('/cart.js')
      .then(response => {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(cart => {
        const cartTotalCents = cart.total_price;
        const remainingCents = Math.max(0, threshold - cartTotalCents);
        const progressPercentage = Math.min(100, (cartTotalCents / threshold) * 100);
        const hasFreeShipping = cartTotalCents >= threshold;

        const fillBar = container.querySelector('.cart-subtotals_freeShippingFill__g389z');
        if (fillBar) {
          const currentWidth = parseFloat(fillBar.style.width) || parseFloat(fillBar.dataset.progress) || 0;
          if (Math.abs(currentWidth - progressPercentage) > 0.1) {
            void fillBar.offsetHeight;
            requestAnimationFrame(() => {
              fillBar.style.width = progressPercentage + '%';
              fillBar.dataset.progress = progressPercentage;
            });
          } else {
            fillBar.style.width = progressPercentage + '%';
            fillBar.dataset.progress = progressPercentage;
          }
        }

        const textEl = container.querySelector('.cart-subtotals_freeShippingText__CZXBh');
        if (textEl) {
          if (hasFreeShipping) {
            textEl.textContent = container.dataset.reachedText || '';
          } else {
            const currency = (cart.currency && cart.currency.iso_code) || container.dataset.currency || '';
            const formattedAmount = formatMoney(remainingCents, currency);
            const amountHtml = `<span class="cart-subtotals_freeShippingMissing__MNW0l" data-remaining="${remainingCents}">${formattedAmount}</span>`;
            const template = container.dataset.deficitText || '';
            textEl.innerHTML = template.replace('__AMOUNT__', amountHtml);
          }
        }
      })
      .catch(() => {})
      .finally(() => { shippingBarFetching = false; });
  }

  document.addEventListener('on:cart:add', requestShippingBarUpdate);
  document.addEventListener('on:line-item:change', requestShippingBarUpdate);
  document.addEventListener('dispatch:cart-drawer:refresh', requestShippingBarUpdate);
  document.addEventListener('on:cart-drawer:after-open', requestShippingBarUpdate);

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        const m = mutations[i];
        if (m.type !== 'childList') continue;
        const target = m.target;
        if (target.classList?.contains('cart-subtotals_freeShipping__container') ||
            target.closest?.('.cart-subtotals_freeShipping__container') ||
            Array.from(m.addedNodes).some(n => n.nodeType === 1 && (
              n.classList?.contains('cart-subtotals_freeShipping__container') ||
              n.querySelector?.('.cart-subtotals_freeShipping__container')
            ))) {
          requestShippingBarUpdate();
          break;
        }
      }
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestShippingBarUpdate);
  } else {
    requestShippingBarUpdate();
  }
})();

/* ==========================================================
   ReConvert / Orbe app – inject styles into shadow DOM
   ========================================================== */
(function () {
  var RECONVERT_CSS = `
    /* ---- Global font override ---- */
    *, *::before, *::after {
      font-family: 'KIKO Pro', sans-serif !important;
    }

    /* ---- Section wrapper ---- */
    .section_content {
      padding: 0 56px 40px !important;
      margin: 0 auto;
      background: #fff;
    }
    @media (max-width: 768px) {
      .section_content { padding: 0 20px 32px !important; }
    }

    /* ---- Heading "You may also like these products" ---- */
    .custom-space,
    .mt-4.custom-space,
    .mt-4.break-words.custom-space {
      text-align: center !important;
      margin-bottom: 32px !important;
    }
    .custom-space *,
    .custom-space span {
      font-family: inherit !important;
      text-decoration: none !important;
    }
    .custom-space .heading_font,
    .custom-space .heading_font p,
    .custom-space .heading_font span,
    .custom-space p,
    .custom-space span {
      text-align: center !important;
      font-size: 40px !important;
      font-weight: 100 !important;
      font-style: normal !important;
      line-height: 105% !important;
      letter-spacing: -0.03em !important;
      font-family: inherit !important;
      text-decoration: none !important;
      -webkit-text-decoration: none !important;
    }
    @media (min-width: 1280px) {
      .custom-space .heading_font,
      .custom-space .heading_font p,
      .custom-space .heading_font span,
      .custom-space p,
      .custom-space span {
        font-size: 72px !important;
        font-style: normal !important;
        font-weight: 100 !important;
        letter-spacing: -2.16px !important;
        line-height: 69.8333px !important;
      }
    }

    /* ---- Scroll container – hidden scrollbar, JS arrows handle navigation ---- */
    .overflow-x-auto,
    .scroll-snap-x {
      overflow-x: auto !important;
      overflow-y: hidden !important;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none !important;
      padding-bottom: 12px !important;
      position: relative;
    }
    .overflow-x-auto::-webkit-scrollbar,
    .scroll-snap-x::-webkit-scrollbar {
      display: none !important;
    }

    /* ---- Slider nav arrows ---- */
    .reconvert-slider-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid rgba(37, 43, 46, 0.12);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: box-shadow 0.2s ease, opacity 0.2s ease;
      opacity: 0.9;
      padding: 0;
    }
    .reconvert-slider-nav:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      opacity: 1;
    }
    .reconvert-slider-nav[disabled] {
      opacity: 0.3;
      cursor: default;
      pointer-events: none;
    }
    .reconvert-slider-nav svg {
      width: 20px;
      height: 20px;
    }
    .reconvert-slider-prev {
      left: -16px;
    }
    .reconvert-slider-next {
      right: -16px;
    }
    @media (max-width: 768px) {
      .reconvert-slider-prev { left: -8px; }
      .reconvert-slider-next { right: -8px; }
      .reconvert-slider-nav { width: 32px; height: 32px; }
      .reconvert-slider-nav svg { width: 16px; height: 16px; }
    }

    /* ---- Row gaps ---- */
    .flex.flex-nowrap {
      gap: 24px !important;
    }

    /* ---- Product images ---- */
    img.product-image {
      aspect-ratio: 0.8 !important;
      object-fit: contain !important;
      border-radius: 0 !important;
      background: #fff;
    }

    /* ---- Product titles (e.g. 3D Hydra Lip Stylo) ---- */
    p.heading_font.break-words,
    .heading_font.break-words p,
    p.heading_font {
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      height: 22px !important;
      letter-spacing: -0.28px !important;
      line-height: 16.8px !important;
      margin: 8px 0 0 !important;
      font-family: inherit !important;
      text-align: center !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    /* ---- HIDE variant name row (uppercase color labels) ---- */
    .mb-1.flex.flex-nowrap:has(span.uppercase) {
      display: none !important;
    }
    .heading_font:not(.break-words):has(> span.uppercase) {
      display: none !important;
    }

    /* ---- Prices – centered like theme card ---- */
    .price_style,
    p.text-left.break-word.leading-normal.price_style {
      font-size: 16px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      height: 15px !important;
      line-height: 15px !important;
      font-family: inherit !important;
      text-align: center !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin-top: 12px !important;
    }
    /* Center the price wrapper too */
    .body_font.text-left {
      text-align: center !important;
    }
    .flex.items-start {
      justify-content: center !important;
    }

    /* ---- Kill the app's .theme_input border ---- */
    .theme_input,
    .section_content .theme_input,
    .section_content .all-widgets .theme_input,
    .all-widgets .theme_input,
    .py-1.theme_input,
    div.theme_input,
    [class*="theme_input"],
    .section_content [class*="theme_input"],
    .section_content .all-widgets [class*="theme_input"] {
      min-height: auto !important;
      border: 0 none transparent !important;
      border-width: 0px !important;
      border-style: none !important;
      border-color: transparent !important;
      outline: none !important;
      box-shadow: none !important;
    }
    .select_input_wrapper {
      padding: 6px 10px !important;
      border: 1px solid rgba(37, 43, 46, 0.15) !important;
      border-radius: 20px !important;
      background: #fff !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 6px !important;
      max-width: 100% !important;
      cursor: pointer !important;
    }
    .select_input_lable {
      display: none !important;
    }
    select.selectVariantStyle,
    select.select_input_container {
      font-size: 12px !important;
      font-weight: 600 !important;
      font-family: inherit !important;
      color: #252b2e !important;
      padding: 0 18px 0 0 !important;
      min-height: auto !important;
      height: auto !important;
      line-height: 1.3 !important;
      border: none !important;
      background: transparent !important;
      appearance: none !important;
      -webkit-appearance: none !important;
      cursor: pointer !important;
      white-space: nowrap !important;
      text-overflow: ellipsis !important;
      overflow: hidden !important;
      max-width: 140px !important;
    }
    .select_input_dropdown_icon {
      right: 6px !important;
      pointer-events: none !important;
    }
    .select_input_dropdown_icon svg {
      width: 8px !important;
      height: 8px !important;
    }
    /* Center the variant row items */
    .flex.flex-nowrap:has(.select_input_wrapper) > div {
      justify-content: center !important;
    }
    /* Center the inner wrapper */
    .flex.flex-nowrap:has(.select_input_wrapper) > div > div {
      display: flex !important;
      justify-content: center !important;
      width: 100% !important;
    }

    /* ---- HIDE quantity selector row ---- */
    .flex.flex-nowrap:has(.quantity_selector_style) { display: none !important; }
    .quantity_selector_style { display: none !important; }

    /* ---- Add to cart button – exact match of theme .quick-add-btn ---- */
    .btn_container {
      margin-top: 12px !important;
      justify-content: center !important;
      text-align: center !important;
    }
    button.theme_button.theme_button_primary,
    .button-container.theme_button,
    button.theme_button {
      display: inline-flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
      width: auto !important;
      padding: 1px 12px !important;
      min-height: 2rem !important;
      border: none !important;
      border-radius: 8px !important;
      background: linear-gradient(0deg, #fff 50%, #252b2e 50%) !important;
      background-size: 100% 200% !important;
      background-position-y: 0% !important;
      background-image: none;
      color: #fff !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1.35 !important;
      text-align: center !important;
      text-transform: uppercase !important;
      letter-spacing: -0.03em !important;
      overflow-wrap: break-word !important;
      overflow: visible !important;
      cursor: pointer !important;
      transition: background-position-y 0.3s ease-out,
                  box-shadow 0.3s ease-out,
                  color 50ms ease-out 0.15s !important;
    }
    button.theme_button.theme_button_primary:hover,
    .button-container.theme_button:hover,
    button.theme_button:hover {
      background-position-y: 100% !important;
      color: #252b2e !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
    }
    .span_style,
    .span_style_primary {
      background: transparent !important;
      color: inherit !important;
      font-weight: inherit !important;
      font-size: inherit !important;
      text-transform: inherit !important;
      letter-spacing: inherit !important;
    }
  `;

  var ARROW_LEFT = '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="m6.797 11.625 8.03-8.03 1.06 1.06-6.97 6.97 6.97 6.97-1.06 1.06z"/></svg>';
  var ARROW_RIGHT = '<svg width="24" height="24" viewBox="0 0 24 24"><path d="m9.693 4.5 7.5 7.5-7.5 7.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>';

  function addSliderArrows(root) {
    if (root.querySelector('.reconvert-slider-nav')) return;

    var scrollContainer = root.querySelector('.overflow-x-auto, .scroll-snap-x');
    if (!scrollContainer) return;

    var wrapper = root.querySelector('.slider-container')
      || root.querySelector('.my-2.relative')
      || scrollContainer.closest('.relative')
      || scrollContainer.parentElement;
    if (!wrapper) return;

    wrapper.style.position = 'relative';
    wrapper.style.overflow = 'visible';

    var prevBtn = document.createElement('button');
    prevBtn.className = 'reconvert-slider-nav reconvert-slider-prev';
    prevBtn.innerHTML = ARROW_LEFT;
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous');

    var nextBtn = document.createElement('button');
    nextBtn.className = 'reconvert-slider-nav reconvert-slider-next';
    nextBtn.innerHTML = ARROW_RIGHT;
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next');

    function getScrollStep() {
      var firstItem = scrollContainer.querySelector('.flex.flex-nowrap > div[style]');
      return firstItem ? firstItem.offsetWidth + 24 : 300;
    }

    function updateButtons() {
      var sl = scrollContainer.scrollLeft;
      var maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      prevBtn.disabled = sl <= 5;
      nextBtn.disabled = sl >= maxScroll - 5;
    }

    prevBtn.addEventListener('click', function () {
      scrollContainer.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      scrollContainer.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });
    scrollContainer.addEventListener('scroll', updateButtons);

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    setTimeout(updateButtons, 200);
  }

  function killThemeInputBorders(root) {
    var inputs = root.querySelectorAll('.theme_input, [class*="theme_input"]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].style.setProperty('border', 'none', 'important');
      inputs[i].style.setProperty('border-width', '0', 'important');
      inputs[i].style.setProperty('min-height', 'auto', 'important');
      inputs[i].style.setProperty('box-shadow', 'none', 'important');
    }
  }

  function injectStylesIntoShadow(shadowRoot) {
    if (shadowRoot.querySelector('[data-reconvert-theme-override]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-reconvert-theme-override', 'true');
    style.textContent = RECONVERT_CSS;
    shadowRoot.appendChild(style);
    setTimeout(function () { killThemeInputBorders(shadowRoot); addSliderArrows(shadowRoot); }, 1500);
    setTimeout(function () { killThemeInputBorders(shadowRoot); addSliderArrows(shadowRoot); }, 3000);
    setTimeout(function () { killThemeInputBorders(shadowRoot); }, 5000);
    setTimeout(function () {
      if (window.__wpopupThemeScan) window.__wpopupThemeScan();
    }, 200);
  }

  function injectStylesIntoIframe(iframe) {
    try {
      var doc = iframe.contentDocument || iframe.contentWindow.document;
      if (!doc || doc.querySelector('[data-reconvert-theme-override]')) return;
      var style = doc.createElement('style');
      style.setAttribute('data-reconvert-theme-override', 'true');
      style.textContent = RECONVERT_CSS;
      doc.head.appendChild(style);
    } catch (e) { /* cross-origin iframe */ }
  }

  function scanForShadowRoots(root) {
    var elements = root.querySelectorAll('*');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (el.shadowRoot) {
        injectStylesIntoShadow(el.shadowRoot);
        scanForShadowRoots(el.shadowRoot);
      }
    }
    var iframes = root.querySelectorAll('iframe');
    for (var j = 0; j < iframes.length; j++) {
      if (iframes[j].contentDocument) {
        injectStylesIntoIframe(iframes[j]);
      } else {
        iframes[j].addEventListener('load', function () {
          injectStylesIntoIframe(this);
        });
      }
    }
  }

  function patchAttachShadow() {
    var origAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function () {
      var shadow = origAttachShadow.apply(this, arguments);
      var shadowRef = shadow;
      setTimeout(function () { injectStylesIntoShadow(shadowRef); }, 0);
      var obs = new MutationObserver(function () {
        injectStylesIntoShadow(shadowRef);
      });
      obs.observe(shadow, { childList: true, subtree: true });
      return shadow;
    };
  }

  function startObserving() {
    patchAttachShadow();
    scanForShadowRoots(document);

    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        for (var n = 0; n < mutations[m].addedNodes.length; n++) {
          var node = mutations[m].addedNodes[n];
          if (node.nodeType !== 1) continue;
          if (node.shadowRoot) {
            injectStylesIntoShadow(node.shadowRoot);
            scanForShadowRoots(node.shadowRoot);
          }
          scanForShadowRoots(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    var retries = 0;
    var interval = setInterval(function () {
      scanForShadowRoots(document);
      retries++;
      if (retries >= 30) clearInterval(interval);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

/* ==========================================================
   Wiser wpopup – simple footer buttons (see custom.css for ATC)
   ========================================================== */
(function () {
  var STYLE_ATTR = 'data-wpopup-theme-styles';
  var scanTimer;
  var retries = 0;
  var MAX_RETRIES = 8;

  function buildInjectCss() {
    return (
      '#wpopup-main-content .wpopup_line_item--infobox{display:flex!important;flex-wrap:nowrap!important;align-items:center!important;gap:12px!important;}' +
      '#wpopup-main-content .wpopup_line_item--info{flex:1 1 auto!important;min-width:0!important;}' +
      '#wpopup-main-content .wpopup_line_item--action{flex:0 0 auto!important;width:auto!important;}' +
      '#wpopup-main-content .wpopup_footer{display:flex!important;flex-direction:column!important;align-items:stretch!important;gap:8px!important;overflow:visible!important;}' +
      '#wpopup-main-content #wpopup-gotocart-btn,#wpopup-main-content .wpopup_gotocart_btn{order:1!important;}' +
      '#wpopup-main-content #wpopup-checkout-btn,#wpopup-main-content .wpopup_checkout_btn{order:2!important;}' +
      '#wpopup-main-content #wpopup-nothanks-btn,#wpopup-main-content .wpopup_nothanks_btn{order:3!important;position:static!important;z-index:auto!important;transform:none!important;}' +
      '#wpopup-main-content #wpopup-gotocart-btn,#wpopup-main-content .wpopup_gotocart_btn{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:40px!important;padding:10px 16px!important;border:none!important;border-radius:8px!important;font-size:14px!important;font-weight:700!important;cursor:pointer!important;box-shadow:0 2px 8px rgba(0,0,0,.15)!important;background:#fff!important;background-image:none!important;color:#202223!important;}' +
      '#wpopup-main-content #wpopup-gotocart-btn span,#wpopup-main-content .wpopup_gotocart_btn span{color:#202223!important;}' +
      '#wpopup-main-content #wpopup-checkout-btn,#wpopup-main-content .wpopup_checkout_btn{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:40px!important;padding:10px 16px!important;border:none!important;border-radius:8px!important;font-size:14px!important;font-weight:700!important;cursor:pointer!important;box-shadow:0 2px 8px rgba(0,0,0,.15)!important;background:#202223!important;background-image:none!important;color:#fff!important;}' +
      '#wpopup-main-content #wpopup-checkout-btn span,#wpopup-main-content .wpopup_checkout_btn span{color:#fff!important;}' +
      '#wpopup-main-content #wpopup-nothanks-btn,#wpopup-main-content .wpopup_nothanks_btn{display:block!important;visibility:visible!important;opacity:1!important;width:100%!important;height:auto!important;min-height:1.25em!important;max-height:none!important;margin:0!important;padding:10px 0!important;font-size:14px!important;font-weight:400!important;line-height:1.4!important;text-align:center!important;text-decoration:underline!important;color:#202223!important;background:transparent!important;box-shadow:none!important;cursor:pointer!important;pointer-events:auto!important;}'
    );
  }

  function injectStyles(target) {
    if (!target) return;
    var style = target.querySelector('[' + STYLE_ATTR + ']');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute(STYLE_ATTR, 'true');
      target.appendChild(style);
    }
    style.textContent = buildInjectCss();
  }

  function applyGoToCart(btn) {
    btn.classList.remove('btn', 'btn--primary', 'btn--secondary');
    btn.style.setProperty('order', '1', 'important');
    btn.style.setProperty('position', 'static', 'important');
    btn.style.setProperty('background', '#ffffff', 'important');
    btn.style.setProperty('background-color', '#ffffff', 'important');
    btn.style.setProperty('background-image', 'none', 'important');
    btn.style.setProperty('color', '#202223', 'important');
    btn.querySelectorAll('span').forEach(function (s) {
      s.style.setProperty('color', '#202223', 'important');
    });
  }

  function applyCheckout(btn) {
    btn.classList.remove('btn', 'btn--primary', 'btn--secondary');
    btn.style.setProperty('order', '2', 'important');
    btn.style.setProperty('position', 'static', 'important');
    btn.style.setProperty('background', '#202223', 'important');
    btn.style.setProperty('background-color', '#202223', 'important');
    btn.style.setProperty('background-image', 'none', 'important');
    btn.style.setProperty('color', '#ffffff', 'important');
    btn.querySelectorAll('span').forEach(function (s) {
      s.style.setProperty('color', '#ffffff', 'important');
    });
  }

  function applyNoThanks(el) {
    el.classList.remove('btn', 'btn--primary', 'btn--secondary');
    el.style.setProperty('order', '3', 'important');
    el.style.setProperty('position', 'static', 'important');
    el.style.setProperty('z-index', 'auto', 'important');
    el.style.setProperty('transform', 'none', 'important');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('text-align', 'center', 'important');
    el.style.setProperty('margin', '4px 0 0', 'important');
    el.style.setProperty('color', '#202223', 'important');
    el.style.setProperty('background', 'transparent', 'important');
    el.style.setProperty('font-size', '14px', 'important');
    el.style.setProperty('text-decoration', 'underline', 'important');
    el.style.setProperty('pointer-events', 'auto', 'important');
  }

  function stylePopup(popup) {
    var root = popup.getRootNode();
    injectStyles(document.head);
    if (root instanceof ShadowRoot) injectStyles(root);

    popup.querySelectorAll('#wpopup-gotocart-btn, .wpopup_gotocart_btn').forEach(applyGoToCart);
    popup.querySelectorAll('#wpopup-checkout-btn, .wpopup_checkout_btn').forEach(applyCheckout);
    popup.querySelectorAll('#wpopup-nothanks-btn, .wpopup_nothanks_btn').forEach(applyNoThanks);
  }

  function findPopups() {
    var popups = [];
    function walk(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('#wpopup-main-content').forEach(function (p) {
        if (popups.indexOf(p) === -1) popups.push(p);
      });
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) walk(el.shadowRoot);
      });
    }
    walk(document);
    return popups;
  }

  function scan() {
    var popups = findPopups();
    for (var i = 0; i < popups.length; i++) stylePopup(popups[i]);
    return popups.length > 0;
  }

  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 120);
  }

  function startRetries() {
    retries = 0;
    var tick = setInterval(function () {
      scan();
      retries++;
      if (retries >= MAX_RETRIES) clearInterval(tick);
    }, 400);
  }

  function start() {
    if (scan()) startRetries();

    if (!document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            node.id === 'wpopup-main-content' ||
            (node.querySelector && node.querySelector('#wpopup-main-content'))
          ) {
            scheduleScan();
            startRetries();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  window.__wpopupThemeScan = function () {
    scan();
    startRetries();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Remove WI-BOGO / rewards progress bar if the app injects it into mobile menu or localization drawer */
(function () {
  var blockedSelectors = [
    'localization-drawer',
    '#kiko-mobile-menu',
    '.menu-mobile_overlay__BvSvP'
  ];
  var barSelector = '.reward_progress_bar_main, [class*="reward_progress_bar"]';

  function cleanupRewardBars() {
    blockedSelectors.forEach(function (blockedSelector) {
      document.querySelectorAll(blockedSelector).forEach(function (container) {
        container.querySelectorAll(barSelector).forEach(function (bar) {
          bar.remove();
        });
      });
    });
  }

  function initRewardBarCleanup() {
    cleanupRewardBars();
    var observer = new MutationObserver(cleanupRewardBars);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRewardBarCleanup);
  } else {
    initRewardBarCleanup();
  }
})();

/* WI BOGO – keep widget below purchase row so it does not displace the wishlist button */
(function () {
  function relocateWiBogoWidget() {
    var wrapper = document.querySelector('.pdp-wrapper .bxgx_widget_wrapper');
    if (!wrapper) return false;

    var slot = document.querySelector('.pdp-wrapper .pdp-bogo-slot');
    if (!slot || slot.contains(wrapper)) return !!slot.contains(wrapper);

    slot.appendChild(wrapper);
    return true;
  }

  function initWiBogoPlacement() {
    relocateWiBogoWidget();

    var pdp = document.querySelector('.pdp-wrapper');
    if (!pdp) return;

    var observer = new MutationObserver(function () {
      relocateWiBogoWidget();
    });
    observer.observe(pdp, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWiBogoPlacement);
  } else {
    initWiBogoPlacement();
  }
})();

/* Breadcrumbs Categories app – lowercase labels so theme capitalize CSS can apply */
(function () {
  function formatBreadcrumbLabels(root) {
    var scope = root || document;
    scope.querySelectorAll('.oh-categories-extension [itemprop="name"]').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (!text || el.dataset.kikoCaseFormatted === 'true') return;
      el.textContent = text.toLowerCase();
      el.dataset.kikoCaseFormatted = 'true';
    });
  }

  function initBreadcrumbCase() {
    formatBreadcrumbLabels();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.oh-categories-extension')) {
            formatBreadcrumbLabels(node);
          } else if (node.querySelector) {
            formatBreadcrumbLabels(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBreadcrumbCase);
  } else {
    initBreadcrumbCase();
  }
})();

/* Wishlist app – show an "out of stock" message and block "Move to cart" for
   sold-out items. The wishlist page is rendered by a third-party app, so we
   read the inventory data it already prints on each variant <option> and layer
   our own state on top. Kept idempotent so the app's re-renders don't loop. */
(function () {
  var LANG = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  var IS_RO = LANG.indexOf('ro') === 0;
  var OOS_LABEL = IS_RO ? 'Stoc epuizat' : 'Sold out';
  var BULK_LEFT_LABEL = IS_RO
    ? 'Produsele epuizate au rămas în lista ta de dorințe.'
    : 'Sold-out items were left in your wishlist.';
  var BULK_NONE_LABEL = IS_RO
    ? 'Toate produsele selectate sunt epuizate.'
    : 'All selected items are sold out.';
  var observer;
  var bulkMsgTimer;

  // Find the <option> for a specific variant id so we judge the exact variant an
  // action will add. Each item's move-cart button and its checkbox can carry
  // different variant ids (the app updates the button on shade change but not the
  // checkbox), so callers pass whichever one they're about to act on. Falls back
  // to the currently selected option.
  function optionForVariant(column, variantId) {
    var select = column.querySelector('.wishlist-variant-picker');
    if (!select) return null;
    if (variantId) {
      for (var i = 0; i < select.options.length; i += 1) {
        if (select.options[i].value === String(variantId)) return select.options[i];
      }
    }
    return select.options[select.selectedIndex] || select.querySelector('option[selected]');
  }

  function isOptionSoldOut(option) {
    if (!option) return false; // no data to judge from – leave the app untouched
    var management = (option.getAttribute('data-inventory_management') || '').trim().toLowerCase();
    var policy = (option.getAttribute('data-inventory_policy') || '').trim().toUpperCase();
    var qty = parseInt(option.getAttribute('data-inventory_quantity') || '0', 10);
    // Not tracked (blank / "null" / "none") → always purchasable.
    if (!management || management === 'null' || management === 'none') return false;
    if (policy === 'CONTINUE' || policy === 'ALLOW') return false; // backorder allowed
    return isNaN(qty) ? false : qty <= 0;
  }

  function applyState(column) {
    var btn = column.querySelector('.wishlist-move-cart');
    if (!btn) return;

    // The per-item button adds its own data-variant_id.
    var soldOut = isOptionSoldOut(optionForVariant(column, btn.getAttribute('data-variant_id')));

    if (btn.disabled !== soldOut) btn.disabled = soldOut;
    btn.classList.toggle('wishlist-move-cart--oos', soldOut);
    var ariaVal = soldOut ? 'true' : 'false';
    if (btn.getAttribute('aria-disabled') !== ariaVal) btn.setAttribute('aria-disabled', ariaVal);

    var msg = column.querySelector('.wishlist-oos-msg');
    if (soldOut) {
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'wishlist-oos-msg';
        msg.setAttribute('role', 'status');
        msg.textContent = OOS_LABEL;
        if (btn.parentNode) btn.parentNode.insertBefore(msg, btn.nextSibling);
      }
    } else if (msg && msg.parentNode) {
      msg.parentNode.removeChild(msg);
    }
  }

  function processAll() {
    var columns = document.querySelectorAll('.wishlist-column');
    if (!columns.length) return;
    if (observer) observer.disconnect();
    columns.forEach(applyState);
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  // Transient note shown under the bulk-action bar.
  function showBulkMessage(text) {
    var bar = document.querySelector('.bulk_action');
    if (!bar || !bar.parentNode) return;
    var msg = document.querySelector('.wishlist-bulk-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'wishlist-bulk-msg';
      msg.setAttribute('role', 'status');
      bar.parentNode.insertBefore(msg, bar.nextSibling);
    }
    msg.textContent = text;
    msg.classList.add('is-visible');
    clearTimeout(bulkMsgTimer);
    bulkMsgTimer = setTimeout(function () {
      if (msg) msg.classList.remove('is-visible');
    }, 6000);
  }

  // The app's own bulk "Move to cart" (#move_to_cart_all) is unsafe for us:
  //   1. It sends every checked item in one cart/add.js call, which is atomic –
  //      a single sold-out line makes the whole batch fail and nothing is added.
  //   2. Its removal endpoint (/move-all-wishlist) clears the ENTIRE wishlist on
  //      the server regardless of what actually made it into the cart, so
  //      sold-out (and even unselected) items silently disappear from the list.
  // So instead of letting it run we take the bulk action over and drive the
  // app's per-item "Move to cart" for each selected in-stock item. The per-item
  // flow (/save-wishlist) adds + removes only that one item, leaving sold-out
  // items untouched in both the cart and the wishlist.
  function stayOnPageEnabled() {
    try {
      return String(window.app_widget_data.is_enable_stay_on_page_after_cart) === '1';
    } catch (e) {
      return false;
    }
  }

  // Click each in-stock item's own "Move to cart" in turn. Sequential (not
  // parallel) so the app finishes one add/remove before the next begins.
  function moveColumnsSequentially(columns, index) {
    if (index >= columns.length) return;
    var column = columns[index];
    var next = function () { moveColumnsSequentially(columns, index + 1); };
    var btn = column && column.querySelector('.wishlist-move-cart');
    if (!btn || btn.disabled || !document.body.contains(btn)) {
      next();
      return;
    }
    btn.click();
    setTimeout(next, 800);
  }

  function handleBulkMoveCapture(e) {
    var trigger = e.target && e.target.closest ? e.target.closest('#move_to_cart_all') : null;
    if (!trigger) return;

    var checked = document.querySelectorAll('.wishlist_item_checkbox:checked');
    if (!checked.length) return; // nothing selected – let the app respond as usual

    var inStockColumns = [];
    var soldOut = 0;
    checked.forEach(function (cb) {
      var col = cb.closest('.wishlist-column');
      if (!col) return;
      // The add uses each checkbox's own data-variant_id, so judge that exact
      // variant (not the picker's current selection).
      if (isOptionSoldOut(optionForVariant(col, cb.getAttribute('data-variant_id')))) {
        soldOut += 1;
      } else {
        inStockColumns.push(col);
      }
    });

    // Without the app's "stay on page after cart" setting the per-item flow
    // redirects to /cart after the first item, which would abort the sequence.
    // Fall back to just un-checking sold-out items and letting the app run – it
    // still adds every in-stock item to the cart (the wishlist gets cleared, but
    // that is the app's own behaviour we can't safely override here).
    if (!stayOnPageEnabled()) {
      checked.forEach(function (cb) {
        var col = cb.closest('.wishlist-column');
        if (col && isOptionSoldOut(optionForVariant(col, cb.getAttribute('data-variant_id')))) {
          cb.checked = false;
        }
      });
      if (!inStockColumns.length) {
        e.stopImmediatePropagation();
        e.preventDefault();
        showBulkMessage(BULK_NONE_LABEL);
      } else if (soldOut > 0) {
        showBulkMessage(BULK_LEFT_LABEL);
      }
      return;
    }

    // Take over completely: block the app's bulk handler and move items one by
    // one so sold-out and unselected items stay in the wishlist.
    e.stopImmediatePropagation();
    e.preventDefault();

    if (!inStockColumns.length) {
      showBulkMessage(BULK_NONE_LABEL);
      return;
    }
    if (soldOut > 0) showBulkMessage(BULK_LEFT_LABEL);
    moveColumnsSequentially(inStockColumns, 0);
  }

  function initWishlistStock() {
    observer = new MutationObserver(processAll);
    processAll();
    observer.observe(document.body, { childList: true, subtree: true });

    // Re-evaluate when the shopper switches variant; wait a tick so the app can
    // update the button's data first.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('wishlist-variant-picker')) {
        setTimeout(processAll, 0);
      }
    });

    document.addEventListener('click', handleBulkMoveCapture, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistStock);
  } else {
    initWishlistStock();
  }
})();
